/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_ReconnectInputs */

const cs_settings_meta_reconnect = /** @type {(inputs: Settings_Meta_ReconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znovu propojit Meta`)
};

const en_settings_meta_reconnect = /** @type {(inputs: Settings_Meta_ReconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnect Meta`)
};

/**
* | output |
* | --- |
* | "Reconnect Meta" |
*
* @param {Settings_Meta_ReconnectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_reconnect = /** @type {((inputs?: Settings_Meta_ReconnectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_ReconnectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_reconnect(inputs)
	return cs_settings_meta_reconnect(inputs)
});